<template>
    <div class="quiz-input" :class="{'has-error': errorText}">
        <label for="location">Project address</label>
        <div ref="dropdown" class="quiz-geo">
            <input
                v-model="input"
                id="location"
                type="text"
                placeholder="Enter your location"
                @input="onSearch"
                @blur="onBlur"
            >
            <Transition name="slide">
                <div v-if="isOpen && suggestions.length" class="quiz-geo__list">
                    <ul>
                        <li v-for="(item, i) in suggestions" :key="i" @click="onSelect(item.value)">
                            {{ item.text }}
                        </li>
                    </ul>
                </div>
            </Transition>
        </div>
        <div v-if="errorText" class="quiz-input-error">
            {{ errorText }}
        </div>
    </div>
</template>

<script>
import { onClickOutside } from '@vueuse/core'
import * as Sentry from '@sentry/browser'

export default {
    emits: ['change'],
    data() {
        return {
            errorText: null,
            tmpGeo: null,
            input: '',
            dropdown: null,
            isOpen: false,
            suggestions: [],
            searchTimer: null,
            outFields: [
                'Match_addr',
                'LongLabel',
                'ShortLabel',
                'Addr_type',
                'StName',
                'StType',
                'StAddr',
                'District',
                'City',
                'MetroArea',
                'Subregion',
                'Region',
                'RegionAbbr',
                'Territory',
                'Zone',
                'Postal',
                'PostalExt',
                'Country',
                'CntryName',
            ],
            error: false,
            arcgisKey: import.meta.env.VITE_ARCGIS_KEY
        }
    },
    mounted() {
        onClickOutside(this.$refs.dropdown, () => this.isOpen = false)
    },
    methods: {
        async fetchSuggestions() {
            try {
                const params = new URLSearchParams({
                    f: 'json',
                    token: this.arcgisKey,
                    text: this.input,
                    countryCode: 'USA',
                })
                const response = await fetch(`https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/suggest?${params.toString()}`)
                if (!response.ok) {
                    const error = new Error()
                    error.name = `[InpurGeo.vue] fetchSuggestions ${response?.status}`
                    error.status = response?.status
                    throw error
                }
                const data = await response.json()
                this.suggestions = []
                data.suggestions.forEach(i => this.suggestions.push({
                    text: i.text,
                    value: i.magicKey,
                }))
                if (this.suggestions.length) {
                    this.isOpen = true
                }
            } catch (error) {
                Sentry.captureException(error, {
                    extra: { text: this.input }
                })
            }
        },
        async fetchGeoPlace(magicKey) {
            const params = new URLSearchParams({
                f: 'json',
                token: this.arcgisKey,
                outFields: this.outFields.join(','),
                langCode: 'en',
                SingleLine: this.input,
                ...(magicKey && { magicKey })
            })
            try {
                const response = await fetch(`https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/findAddressCandidates?${params.toString()}`)
                if (!response.ok) {
                    const error = new Error()
                    error.name = `[InpurGeo.vue] fetchGeoPlace ${response?.status}`
                    error.status = response?.status
                    throw error
                }
                const data = await response.json()
                if (data.candidates && data.candidates.length) {
                    this.tmpGeo = {
                        attributes: data.candidates[0].attributes,
                        location: data.candidates[0].location
                    }
                    this.$emit('change', this.tmpGeo)
                    this.input = this.tmpGeo.attributes?.LongLabel
                    this.isOpen = false
                    this.errorText = null
                }
            } catch (error) {
                Sentry.captureException(error, {
                    extra: {
                        SingleLine: this.input,
                        ...(magicKey && { magicKey })
                    }
                })
            }
        },
        onSearch() {
            if (this.input.length > 2) {
                this.errorText = null
                clearTimeout(this.searchTimer)
                this.searchTimer = setTimeout(() => {
                    this.fetchSuggestions()
                }, 400)
            } else {
                clearTimeout(this.searchTimer)
                this.suggestions = []
                this.isOpen = false
                this.tmpGeo = null
                this.$emit('change', this.tmpGeo)
            }
        },
        onSelect(value) {
            this.fetchGeoPlace(value)
        },
        onBlur() {
            setTimeout(() => {
                if (!this.tmpGeo) {
                    if (this.input.length) this.errorText = 'Location incorrect'
                    else this.errorText = 'Location is required'
                }
            }, 200)
        }
    }
}
</script>